import Vue from 'vue'
import { ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

setInteractionMode('lazy')
